/*!
 ** Project:      Chipmunk Theme
 ** Author:       Made by Less
 ** Author URI:   https://madebyless.com
 ** ------------------------------------
 */

import ui from './utils/ui';
import panels from './utils/panels';

// Panels
panels.init();

// UI
ui.init();
